exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-fluid{\r\n    background-color: black;\r\n}\r\n\r\n#footer{    \r\n    color: white;\r\n    line-height: 3rem;\r\n}\r\n\r\n.footer-enlaces{\r\n    background-color: #2a2a2a;\r\n    text-align: center;\r\n}\r\n\r\n.footer-legal{\r\n    background-color: black;\r\n    text-align: center;\r\n}\r\n\r\n.footer-enlaces, .footer-legal{\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n}\r\n\r\n\r\n@media screen and (max-width: 767px) {\r\n    .footer-legal{\r\n        line-height: 1rem;\r\n    }   \r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n    .footer-enlace-izq{\r\n        text-align: left;\r\n        padding-left: 5rem;\r\n    }\r\n\r\n    .footer-enlace-der{\r\n        text-align: right;\r\n        padding-right: 5rem; \r\n    }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/src/app/componentes/footer/footer.component.css
// module id = ../../../../../src/app/componentes/footer/footer.component.css
// module chunks = 1